import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import { getBaseUrl } from '../../utils/common';
import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex)
const base_url = getBaseUrl();

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("culture_token"),
    user: {},
    userprofile: {
      small_photo: "",
    },
    businessprofile: {},
    userphoto: {},
    cart: [],
    notifications: [],
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.user = payload;
    },
    auth_token(state, payload) {
      state.token = payload;
    },
    auth_error(state) {
      state.status = "error";
    },
    auth_profile(state, payload) {
      state.userprofile = payload;
    },
    business_profile(state, payload) {
      state.businessprofile = payload;
    },
    add_cart(state, payload) {
      state.cart = payload;
      state.cart = state.cart.filter(
        (e, i) =>
          state.cart.findIndex((a) => a["product_id"] === e["product_id"]) === i
      );
    },
    set_avartar(state, payload) {
      state.userphoto = payload;
    },
    reset_cart_state(state) {
      state.cart = [];
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = "";
      state.isAuthenticated = "";
      state.userprofile = "";
      state.userphoto = "";
    },
    user_notifications(state, payload) {
      state.notifications = payload;
    },
  },
  actions: {
    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/auth/signin`,
          data: user,
          method: "POST",
        })
          .then((resp) => {
            if (resp.status == "200") {
              const token = resp.data.token;
              const user = resp.data.data;
              localStorage.setItem("culture_token", token);
              // Add the following line:
              axios.defaults.headers.common[
                "Authorization"
              ] = `Bearer ${token}`;
              commit("auth_success", user);
              commit("auth_token", token);
              dispatch("getProfile");
              resolve(resp);
            } else if (resp.status === "422") {
              resolve(resp);
            } else {
              const user = resp.data.data;
              commit("auth_success", user);
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("culture_token");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/auth/signup`,
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const user = resp.data.data;
            // Add the following line:
            commit("auth_success", user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            reject(err);
          });
      });
    },
    confirmPin({ commit }, code) {
      return new Promise((resolve, reject) => {
        const email = this.state.user.email;
        axios
          .get(`${base_url}/api/v2/auth/email/verify`, {
            params: {
              email: email,
              code: code,
            },
          })
          .then((resp) => {
            const user = resp.data.data;
            commit("auth_success", user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    resendCode({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const email = this.state.user.email;
        axios
          .get(`${base_url}/api/v2/auth/email/verify/code`, {
            params: {
              email: email,
            },
          })
          .then((resp) => {
            const user = resp.data.data;
            commit("auth_success", user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/auth/signout`,
          method: "POST",
        })
          .then((resp) => {
            commit("logout");
            localStorage.removeItem("culture_token");
            commit("auth_token", '');
            axios.defaults.headers.common["Authorization"] = null;
            //toastr.success(resp.data.message);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    updateProfile({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/auth/profile/update`,
          data: user,
          method: "POST",
        })
          .then((resp) => {
            const profile = resp.data.data;
            commit("auth_profile", profile);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    createBusinessProfile({ commit }, profile) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/business`,
          data: profile,
          method: "POST",
        })
          .then((resp) => {
            const profile = resp.data.data;
            commit("business_profile", profile);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    updateBusinessProfile({ commit }, profile) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/business/${profile.businessId}?_method=PUT`,
          data: profile.data,
          method: "POST",
        })
          .then((resp) => {
            const profile = resp.data.data;
            commit("business_profile", profile);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    updateProfilePic({ commit, dispatch }, pic) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/dashboard/profile/update-avatar`,
          data: pic,
          method: "POST",
        })
          .then((resp) => {
            const photo = resp.data.data;
            commit("set_avartar", photo);
            dispatch("getProfile");
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    getProfile({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/auth/profile`,
          params: {
            auth_user_id: this.state.user.user_id,
          },
          method: "GET",
        })
          .then((resp) => {
            commit("auth_profile", resp.data.data);
            commit("business_profile", resp.data.business_profile);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    getBusinessProfile({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const business_id = this.state.businessprofile.business_id;
        axios({
          url: `${base_url}/api/v2/business/${business_id}`,
          method: "GET",
        })
          .then((resp) => {
            commit("business_profile", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    getNotifications({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${base_url}/api/v2/activities?logus=1`,
          method: "GET",
        })
          .then((resp) => {
            commit("user_notifications", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            reject(err);
          });
      });
    },
    check({ commit }, logstate) {
      return new Promise((resolve) => {
        commit("auth_token", logstate);
        resolve(logstate);
      });
    },
    addtoCart({ commit }, item) {
      return new Promise((resolve) => {
        const cart = [{ ...item.product }, ...this.state.cart];
        commit("add_cart", cart);
        resolve(item);
      });
    },
    resetCart({ commit }) {
      commit("reset_cart_state");
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    currentUser: (state) => state.user,
    userprofile: (state) => state.userprofile,
    businessprofile: (state) => state.businessprofile,
    user_token: (state) => state.token,
    avartar: (state) => state.userphoto,
    cart: (state) => state.cart,
    notifications: (state) => state.notifications
  },
  modules: {},
  plugins: [createPersistedState({ storage: window.localStorage })],
});
